import { render, staticRenderFns } from "./ProspectBadge.vue?vue&type=template&id=032175d4&scoped=true"
import script from "./ProspectBadge.vue?vue&type=script&lang=ts"
export * from "./ProspectBadge.vue?vue&type=script&lang=ts"
import style0 from "./ProspectBadge.vue?vue&type=style&index=0&id=032175d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_css-loader@6.11.0_underscore@1.13.6_vue-template-compiler@2.7.14_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032175d4",
  null
  
)

export default component.exports